import { create } from 'zustand';
import { api } from '../lib/api';
import { disposeSocket } from '../lib/socket';

interface User { id: string; name: string; avatar: string | null; isGuest: boolean }

interface SessionState {
  user: User | null;
  loading: boolean;
  refresh: () => Promise<void>;
  setUser: (u: User | null) => void;
  logout: () => Promise<void>;
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  loading: true,
  setUser: (u) => set({ user: u, loading: false }),
  refresh: async () => {
    set({ loading: true });
    try {
      const me = await api.me();
      set({ user: me, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
  logout: async () => {
    try { await api.logout(); } catch {}
    // The socket's identity is fixed at handshake time — without tearing it
    // down, the next sign-in keeps acting as the previous account.
    disposeSocket();
    set({ user: null });
  },
}));
